import styled from "styled-components";

const CustomLabel = styled.div`
  color: var(--elementDim);
  font-size: 15px;
  font-weight: 600;
  text-transform: capitalize;
`;

export default CustomLabel;
